<template>
	<div class="clx-home">
		<titles :names="'home'"></titles>
		<!-- 主体 -->
		<div class="clx-home-main">
			<div class="clx-home-main-background"></div>

			<!-- 浮动文字 -->
			<div class="clx-home-float-text">
				<ball @ballSearch="ballSearch"></ball>
			</div>
			<!-- 语音搜索 -->
			<div class="speechsoundbox">
				<div class="speechsoundimg" @click.shop="tosearchsound()" @touchstart="gtouchstart()"
					@touchmove="gtouchmove()" @touchend="showDeleteButton()">
					<img v-if="issound" src="../../assets/clx-images/speechsound.gif"
						style="max-width: 150%;max-height: 150%;z-index:98;margin: 0 0 0 0.1rem" />
					<img v-else src="../../assets/clx-images/souds.png"
						style="max-width: 100%;max-height:100%;z-index: 98;" />
				</div>
				<span class="longtouchsoud">长按语音搜索</span>
			</div>
		</div>
		<!-- <div class="bottom-message">
			<span style="color: #fff;">长城新媒体集团</span>
			<span style="color:#AAFFFE ;margin-left:10px;" @click="showzhuchuangs">主创团队</span>
		</div> -->
		<div class="zhuchuang" v-if="zhuchuangs">
			<div class="zhuchuang-zhezhao" @click="closezhuchuang"></div>
			<div class="zhuchuang-messbox" @click="closezhuchuang">
				<div class="zhuchuang-text">
					<div class="zhuchuang-textbox">
						<span>总策划：王悦路</span>
						<span>策&nbsp;&nbsp;&nbsp;划：曹朝阳</span>
						<span>统&nbsp;&nbsp;&nbsp;筹：周杨</span>
						<span>设&nbsp;&nbsp;&nbsp;计：周杨、冯少玲</span>
						<span>制&nbsp;&nbsp;&nbsp;作：赵娜</span>
						<span>编&nbsp;&nbsp;&nbsp;辑：赵琦</span>
					</div>
				</div>
				<div class="bottom-imgbox">
					<img src="../../assets/clx-images/logo2.png" alt="logo" />
				</div>
			</div>
			<!-- <div class="excitbigbox">
				<div class="excitbox" @click="closezhuchuang">
					<img src="../../assets/clx-images/zhuchuangexcit.png" alt=""
						style="max-width: 40%;display: block;z-index: 97;">
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import config from '@/config'
	import ball from '../../components/ball/index'
	import titles from '../../components/pagetitle/title'
	import Recorder from 'js-audio-recorder'
	import lamejs from 'lamejs'
	import axios from 'axios'
	import {
		openShareAll
	} from "@/libs/wechat";
	const recorder = new Recorder({
		sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
		sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
		numChannels: 1, // 声道，支持 1 或 2， 默认是1
		// compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
	})
	// const lamejs = require('lamejs')
	export default {
		name: "home-c",
		components: {
			ball,
			titles
		},
		data() {
			return {
				menuShowState: false, //目录显示
				keyword: '', //输入框内容
				issound: false,
				timeOutEvent: 0,
				music: "",
				isquanxian: false,
				zhuchuangs: false,
			}
		},
		mounted() {
			let userInfo = JSON.stringify({
				home: 'home'
			})
			sessionStorage.setItem('userInfo', userInfo)
			this.getPermission()
			// var Img = require('../../assets/clx-images/sharephoto.jpg');//实际自己的图片路径地址
			// var url = window.location.href;
			// var hosts = url.split('index.html')[0];//获取域名加打包文件夹名称
			// var shareImg = hosts.concat(Img);
			// let config={
			// 	title: '河北1+20惠企政策＂一点通＂', // 分享标题
			// 	desc: '光明日报与长城新媒体联合推出实用、有趣的民法典“掌中宝”。', // 分享描述
			// 	link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
			// 	imgUrl: shareImg, // 分享图标
			// }
			// console.log(config)
			// openShareAll(config).then((res)=>{
			// })
			// .catch((err)=>{

			// })
		},
		methods: {
			// 显示目录
			menuShow() {
				this.menuShowState = true
			},
			// 隐藏目录
			menuHide() {
				this.menuShowState = false
			},
			// 查询
			iSearch() {
				if (!this.keyword) {
					this.$clxTools.iMessage(this, 'e', '请输入内容后查询', 4)
					return
				}
				this.$router.push({
					name: 'result',
					params: {
						keyword: this.keyword
					}
				})
			},
			// 点击球体文字
			ballSearch(text) {
				this.keyword = text
				this.iSearch()
			},
			// tosearchsound() {
			// 	console.log("调起语音识别")
			// },
			gtouchstart() {
				var self = this;
				this.timeOutEvent = setTimeout(function() {
					self.longPress();
				}, 300); //这里设置定时器，定义长按500毫秒触发长按事件
				return false;
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			showDeleteButton() {
				clearTimeout(this.timeOutEvent); //清除定时器
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（如onclick事件）
					console.log("点击但未长按");
				}
				this.issound = false
				this.onEndVoice()
				return false;
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
			gtouchmove() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			//真正长按后应该执行的内容
			longPress(val) {
				this.timeOutEvent = 0;
				//执行长按要执行的内容，如弹出菜单
				console.log("长按");
				this.issound = true
				this.start()
			},
			start() {
				// this.getPermission()
				console.log(this.isquanxian)
				if (this.isquanxian) {
					let _this = this
					recorder.start().then(() => {
						// 开始录音
						recorder.onprogress = function(params) {
							_this.duration = params.duration.toFixed(2)
							// console.log('dur--', this.duration)
							console.log('录音时长(秒)', params.duration.toFixed(2));
							let dataArray = recorder.getRecordAnalyseData();
							//          console.log('dataArray--', dataArray)
						}
					}, (error) => {
						// 出错了
						console.log(`${error.name} : ${error.message}`);
					})
				} else {
					this.$clxTools.iMessage(this, 'e', '录音权限获取失败', 4)
				}

			},
			/**
			 *  获取麦克风权限
			 * */
			getPermission() {
				Recorder.getPermission().then((promise) => {
					console.log('给权限了', promise);
					this.isquanxian = true
				}, (error) => {
					console.log(`${error.name} : ${error.message}`);
					// this.$clxTools.iMessage(this, 'e', '录音权限获取失败', 4)
				});
			},
			onEndVoice() { //结束录音方法调用
				recorder.stop()
				let instance = axios.create({
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				let contentType = "application/json";
				let mp3Name = encodeURIComponent('audio_recording_' + new Date().getTime() + '.mp3');
				let formData = new FormData()
				// let file = this.convertToMp3(recorder.getWAV())
				let file = recorder.getPCMBlob();
				file = new File([file], mp3Name)
				console.log("上传文件", file, file.size)
				formData.append("file", file)
				formData.append("mp3Name", mp3Name)
				console.log("上传文件1", formData)
				if (this.timeOutEvent == 0 && file.size != 0) {
					instance.post('/prod-api/common/upload', formData).then(res => {
							if (res.data.code == 500) {
								this.$clxTools.iMessage(this, 'e', '请重新录音', 4)
							} else {
								recorder.destroy()
								console.log('res---', res)
								this.$router.push({
									name: 'result',
									params: {
										music: res.data.fileName,
										keyword: this.keyword
									}
								})
							}

						})
						.catch((err) => {
							this.$clxTools.iMessage(this, 'e', '请重试', 4)
							recorder.destroy()
						})
					// let postData=formData
					// 	this.$clxapi.postfileupload(postData)
					// 		.then(res => {
					// 			if(res.data.code==500){
					// 				this.$clxTools.iMessage(this, 'e', '请重新录音', 4)
					// 			}else{
					// 				recorder.destroy()
					// 				console.log('res---', res)
					// 				this.$router.push({
					// 					name: 'result',
					// 					params: {
					// 						music: res.data.fileName,
					// 						keyword: this.keyword
					// 					}
					// 				})
					// 			}

					// 		})
					// 		.catch((err)=>{
					// 			this.$clxTools.iMessage(this, 'e', '请重试', 4)
					// 		})
				} else {
					this.$clxTools.iMessage(this, 's', '长按录制语音', 2)
					recorder.destroy()
				}


			},
			showzhuchuangs() {
				this.zhuchuangs = true
			},
			closezhuchuang() {
				this.zhuchuangs = false
			},
		},
		created() {
			// this.isquanxian = this.$route.params.isquanxian
			this.getPermission()
			if(window.screen.width>750){
				console.log("",window.screen.width)
				const html = document.querySelector('html');
				const width =window.screen.width
				html.style.fontSize = width/13 +'px'
			}
			// this.$clxapi.getWechatConfig({})
			// .then((res)=>{
			// 	console.log(res)
			// 	wx.config({
			// 	  debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
			// 	  appId: res.data.data.appId, // 必填，公众号的唯一标识
			// 	  timestamp:res.data.data.timestamp , // 必填，生成签名的时间戳
			// 	  nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
			// 	  signature: res.data.data.signature,// 必填，签名
			// 	  jsApiList: res.data.data.jsApiList // 必填，需要使用的 JS 接口列表
			// 	});
			// 	wx.checkJsApi({
			// 	  jsApiList: ["updateAppMessageShareData"], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
			// 	  success: function(res) {
			// 	  // 以键值对的形式返回，可用的 api 值true，不可用为false
			// 	  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
			// 	  }
			// 	});
			// 	var Img = require('../../assets/clx-images/sharephoto.jpg');//实际自己的图片路径地址
			// 	var url = window.location.href;
			// 	var hosts = url.split('index.html')[0];//获取域名加打包文件夹名称
			// 	var shareImg = hosts.concat(Img);
			// 	wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
			// 	  wx.updateAppMessageShareData({ 
			// 	    title: '河北1+20惠企政策＂一点通＂', // 分享标题
			// 	    desc: '光明日报与长城新媒体联合推出实用、有趣的民法典“掌中宝”。', // 分享描述
			// 	    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
			// 	    imgUrl: shareImg, // 分享图标
			// 	    success: function (res) {
			// 	      // 设置成功
			// 		  console.log(res)
			// 	    }
			// 	  })
			// 	}); 
			// })
			// .catch((err)=>{

			// })
		},
	};
</script>
<style>
	* {
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	div {
		-webkit-user-select: none;
		-webkit-touch-callout: none;
	}

	img {
		-webkit-touch-callout: none;
		pointer-events: none;
	}
</style>
<style lang="less">
	.clx-home {
		width: 7.5rem;
		padding: 0 0.24rem;
		margin: 0 auto;
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		-webkit-user-select: none;
		-webkit-touch-callout: none;
		background: url(../../assets/clx-images/big-bg2.jpg) no-repeat center 0px;
		background-size: cover;

		// 主体
		.clx-home-main {
			// height: ~"calc(100vh - 7.5rem)";
			height: 58%;
			// min-height: 5rem;
			position: relative;
			border-radius: 0.1rem;
			width: 100%;

			.clx-home-main-background {
				top: 0;
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: #fff;
				border-radius: 0.2rem;
				border: 0.01rem solid #FFC35D;
				opacity: 0.3;
			}

			//浮动文字
			.clx-home-float-text {
				width: 100%;
				// height: ~"calc(100% - 3rem)";
				height: 60%;
				margin: 0.2rem 0 0.4rem 0;
			}

			// 语音搜索
			.speechsoundbox {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				// margin-top: -80px;

				.speechsoundimg {
					width: 1.7rem;
					height: 1.7rem;
					z-index: 94;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.speechsoundimg img {
					-webkit-touch-callout: none;
					pointer-events: none;
				}

				.longtouchsoud {
					display: block;
					width: 50%;
					height: 0.65rem;
					background: url(../../assets/clx-images/longtouch.png) no-repeat center 0px;
					background-size: cover;
					color: #F8FBF3;
					font-size: 0.3rem;
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 0.1rem 0;
				}
			}
		}

		.bottom-message {
			z-index: 10;
			position: relative;
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			font-size: 0.26rem;
			margin: 0.1rem;
		}

		.zhuchuang {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100vh;
			z-index: 95;
			

			.zhuchuang-zhezhao {
				position: fixed;
				z-index: 95;
				// background-color: #dadada;
				// opacity: 0.9;
				background-image: url(../../assets/clx-images/zhuchuangbg.png) ;
				background-size: cover;
				top: 0;
				left: 0;
				width: 100%;
				height: 100vh;
				overflow: hidden;
			}

			.zhuchuang-messbox {
				width: 100%;
				height: 100vh;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				z-index: 96;

				.zhuchuang-text {
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					z-index: 96;
					// margin-left: 0.7rem;
					padding-left: 0.7rem;
				}

				.zhuchuang-textbox {
					color: #000;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: flex-start;
				}

				.zhuchuang-textbox span {
					display: block;
					margin-bottom: 10px;
					font-size: 0.32rem;
					color: #fff;
					font-weight:500;
				}

				.bottom-imgbox {
					z-index: 96;
					width: 100%;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					margin-top: 0.36rem;
				}

				.bottom-imgbox img {
					max-width: 35%;

				}
			}

			.excitbigbox {
				width: 100%;
				position: fixed;
				z-index: 96;
				top: 30px;
				left: 30px;
				padding-right: 10px;
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				align-items: center;
			}

			.excitbox {}
		}
	}

	@media screen and (max-height: 660px) {
		.clx-home-float-text {
			width: 100%;
			height: ~"calc(100% - 3rem)";
			padding: 0.2rem 0;
		}
	}
</style>
